<template>
    <div>
        <p class="kgr-paragraph">
            {{ $t('Aktiviere hier die Benachrichtigung per E-Mail. Du wirst über Neuigkeiten dann bequem und direkt an deine in Clubity hinterlegte E-Mail-Adresse informiert.') }}
        </p>
        <div class="kgr-inputGroup">
            <kgr-checkbox
                v-model="accountSettings.notifyEvents"
                :label="$t('über Kalendereinträge benachrichtigen')"
                @change="emit()"
            />
        </div>

        <div class="kgr-inputGroup">
            <kgr-checkbox
                v-model="accountSettings.notifyTasks"
                :label="$t('über Aufgaben benachrichtigen')"
                @change="emit()"
            />
        </div>

        <div class="kgr-inputGroup">
            <kgr-checkbox
                v-model="accountSettings.notifyNews"
                :label="$t('über Nachrichten benachrichtigen')"
                @change="emit()"
            />
        </div>

        <div class="kgr-inputGroup">
            <kgr-checkbox
                v-model="accountSettings.notifyFiles"
                :label="$t('über hochgeladene Dateien benachrichtigen')"
                @change="emit()"
            />
        </div>

        <template v-if="offeringModuleEnabled">
            <div class="kgr-inputGroup">
                <kgr-checkbox
                    v-model="accountSettings.notifyOfferings"
                    :label="$t('über Angebote benachrichtigen (Terminänderungen, Absagen, Terminreaktivierungen)')"
                    @change="emit()"
                />
            </div>
        </template>
    </div>
</template>

<script>
import AccountSettings from '../../js/dto/AccountSettings.js';
import Checkbox from '../common/form/checkbox/Checkbox.vue';

export default {
    components: {
        'kgr-checkbox': Checkbox,
    },
    props: {
        clubEmployee: {
            type: AccountSettings,
            required: true,
        },
        offeringModuleEnabled: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            accountSettings: null,
        }
    },
    created() {
        this.accountSettings = this.clubEmployee;
    },
    methods: {
        emit() {
            this.$emit('change', this.accountSettings);
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
